import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CampanhaStatusModule } from '../status';
import { CampanhaRecursoViewModule } from '../recursos/view';
import { CampanhaResultadoViewModule } from '../resultado/view';
import { CampanhaROIWidgetsModule } from '../roi/components/widgets';
import { CampanhaVigenciaFormModule } from '../vigencia/form';
import { ClienteTypeaheadSharedModule } from '../../../pessoa/cliente/typeahead';
import { CidadeModule } from '../../../cidade/cidade.module';
import { CampanhaPromocaoFormModule } from '../promocao/form';
import { CampanhaRepresentanteModule } from '../representantes';
import { CampanhaPedidoLiberarModule } from '../pedidos/liberar';
import { CampanhaCuponsFormModule } from '../components/cupons-form';
import { CampanhaTabelaPrecoFormModule } from '../tabelas-precos/form/campanha-tabela-preco-form.module';
import { ArquivoCardViewModule } from '../../../arquivos/arquivos/components/card-view';

import { CampanhaVisualizarModalComponent } from './campanha-visualizar-modal.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaStatusModule,
        CampanhaROIWidgetsModule,
        CampanhaRecursoViewModule,
        CampanhaResultadoViewModule,
        CampanhaVigenciaFormModule,
        CampanhaPromocaoFormModule,
        CampanhaRepresentanteModule,
        ClienteTypeaheadSharedModule,
        CidadeModule,
        CampanhaPedidoLiberarModule,
        CampanhaCuponsFormModule,
        CampanhaTabelaPrecoFormModule,
        ArquivoCardViewModule
    ],
    declarations: [
        CampanhaVisualizarModalComponent
    ],
    exports: [
        CampanhaVisualizarModalComponent
    ]
})
export class CampanhaVisualizarModalModule { }
